export const EVENT_ERROR = 'toolbar.error'
export const EVENT_PROFILE_ITEM_CLICK = 'profile.item.click'
export const EVENT_BURGER_MENU_CLICK = 'burger.container.click'
export const EVENT_LANGUAGE_ITEM_CLICK = 'language.item.click'
export const EVENT_CLIENT_ADD_BUTTON_CLICK = 'client.add_button.click'



// WEBPACK FOOTER //
// ./src/events/Toolbar.js